import styled from "styled-components";
import { color } from "../../../shared/styles";

export const SingleMaterialContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const ContentWrapper = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-radius: 5px;
    background-color: ${color.emphasis.NEUTRAL_N0};
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: none;
    height: auto;
`;

export const ProductOrderLinkedTitle = styled.div`
    color: #333739;
    text-align: left;
    font-family: "Noto Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 150% */
`;

export const ProductOrderLinkedWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
`;

export const InfoBoxWrapper = styled.div`
    background-color: white;
    border-radius: 5px;
    min-height: fit-content;
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: none;
    height: auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .text {
        font-family: Noto Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
`;

export const InfoBoxTitle = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
`;